import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { IPixelCustomDataParameters } from '@faire/web-api--source/indigofair/data/IPixelCustomDataParameters';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'signup-retailer_sign_up_complete-action_unknown';

/**
 * A retail user has successfully created their account
 */
export function trackSignupRetailerSignUpComplete(
  retailer_token: string,
  pixelCustomDataParams?: IPixelCustomDataParameters
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    facebookPixelEvent: 'CompleteRegistration',
    googleTagManagerEvent: 'if-sign-up',
    pixelCustomDataParams,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: { retailer_token },
  });
}
